import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';

import { AppRoute } from '@/common/app/routes';
import { H1, StringSmall } from '@/components/Typography/Typography';
import { useAppSelector } from '@/redux/store';

import css from './style.module.scss';

function formatTimer(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);

  return `${String(h).padStart(2, '0')}h : ${String(m).padStart(2, '0')}m`;
}

const BingoEventCard: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const bingoEvent = useAppSelector((state) => state.shop.bingoEvent);

  if (!bingoEvent || bingoEvent.endsInSeconds <= 0) return null;

  return (
    <button
      onClick={() => navigate(AppRoute.BINGO)}
      className={cn(
        css.arenaOffer,
        css.purple,
        'relative z-[1] flex items-center justify-between py-3 px-4 w-full text-left',
      )}
    >
      <div>
        <H1 className="!text-base !leading-none">{t('Bingo Event')}</H1>
        <StringSmall className="!text-[0.625rem] !text-[#E7D7FF] mt-0.5">
          {t('Open cells, complete lines, win big rewards!')}
        </StringSmall>
      </div>
      <div className="flex-shrink-0 rounded-lg bg-white/10 backdrop-blur-sm px-3 py-1.5">
        <StringSmall weight="bold" className="!text-white text-nowrap">
          {formatTimer(bingoEvent.endsInSeconds)}
        </StringSmall>
      </div>
    </button>
  );
};

export default BingoEventCard;
